import { Dispatch } from 'redux';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';

export const START_PATCH_ACCOUNT = 'START_PATCH_ACCOUNT';
export const PATCH_ACCOUNT_COMPLETED = 'PATCH_ACCOUNT_COMPLETED';
export const START_ACCOUNT_CHANGE = 'START_ACCOUNT_CHANGE';
export const ACCOUNT_CHANGE_COMPLETED = 'ACCOUNT_CHANGE_COMPLETED';
export const ACCOUNT_LAST_CHECKED_UPDATE = 'ACCOUNT_LAST_CHECKED_UPDATE';

const startPatch = () => {
    return { type: START_PATCH_ACCOUNT };
};

const patchCompleted = () => {
    return { type: PATCH_ACCOUNT_COMPLETED };
};

const startAccountChange = () => {
    return { type: START_ACCOUNT_CHANGE };
};

const accountChangeCompleted = () => {
    return { type: ACCOUNT_CHANGE_COMPLETED };
};

export const updateAccountLastChecked = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(startPatch());

        await api.account.updateAccountLastChecked();

        dispatch({ type: ACCOUNT_LAST_CHECKED_UPDATE });

        dispatch(patchCompleted());
    };
};

export const changeAccount = (accountId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(startAccountChange());

        await api.account.changeAccount(accountId);

        dispatch(accountChangeCompleted());
    };
};
